import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";
import WeeklyPrograms from "../components/WeeklyPrograms"
import Contact from "../components/Contact";
import UpcomingPrograms from "../components/UpcomingPrograms";
// eslint-disable-next-line no-unused-vars
import SignUp from "../components/SignUp";
import IndividualSignup from "../components/IndividualSignup";
// eslint-disable-next-line no-unused-vars
import FamilySignup from "../components/FamilySignup";
import Announcement from "../components/Announcement";
import Societies from "../components/Societies";
import Login from "../components/Login";
import Dash from "../components/dashboard/Dash";
import DashHome from "../components/dashboard/DashHome";
import FamilyMember from "../components/dashboard/FamilyMember";
import EditParishioner from "../components/dashboard/EditParishioner";

Vue.use(Router);

export default new Router({
  mode:"history",
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/weeklyprograms',
      name: 'WeeklyPrograms',
      component: WeeklyPrograms
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/upcomingprograms',
      name: 'UpcomingPrograms',
      component: UpcomingPrograms
    },
    // {
    //   path: '/signup',
    //   name: 'SignUp',
    //   component: SignUp
    // },
    {
      path:'/signup',
      name: 'IndividualSignup',
      component: IndividualSignup
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/family-signup',
    //   name: 'FamilySignup',
    //   component: FamilySignup
    // },
    {
      path: '/announcement',
      name: 'Announcement',
      component: Announcement
    },
    {
      path: '/societies',
      name: 'Societies',
      component: Societies
    },
    {
      path: '/download',
      name: 'AppDownload',
      component: ()=>import("../components/AppDownload")
    },
    {
      path: '/admin',
      beforeEnter() {location.href = 'https://admin.parishbulletin.org'}
    },
    {
      path: '/dashboard',
      component: Dash,
      children: [
        {
          path:"",
          name: "Dashboard",
          component: DashHome
        },
        {
          path:"family-members",
          name: "FamilyMembers",
          component: FamilyMember
        },
        {
          path:"edit-info",
          name:"EditParishioner",
          component: EditParishioner
        }
      ]
    },
    {
      path: '/webmail',
      beforeEnter() {
        // Put the full page url including the protocol http(s) below
        window.location = "http://217.174.152.38/webmail"
      }
    },
    {
      path: '/cpanel',
      beforeEnter() {
        // Put the full page url including the protocol http(s) below
        window.location = "http://217.174.152.38/cpanel"
      }
    },
    {
      path: '/admin',
      beforeEnter() {
        // Put the full page url including the protocol http(s) below
        window.location = "https://admin.parishbulletin.org"
      }
    }
  ]
})